import { getReq } from "./instance";

export const getTarget = async (targetId: string, params = {}) => {
  return getReq(`/Target/${targetId}`, params);
};
